// extracted by mini-css-extract-plugin
export default {"card":"K7-z"};